/**
 * The two controls that answer "can this list run, and if not, why?" — the Re-Run button's
 * disabled reasons and, for a list whose leads were added by hand, the note that stands where a
 * setup prompt used to (PREC-4118). Spread into `en.ts` under the `list.` namespace.
 */
export const enListRerun = {
	rerun: "Re-Run List",
	running: "Running…",
	disabledSourceMissing: "Add a list source before re-running.",
	disabledStopping: "List is stopping. Please wait.",
	disabledArchived: "This list is archived. Unarchive it to run it.",
};

/**
 * A list whose leads were added by hand has no file to re-read. It is not unconfigured — it simply
 * cannot run — so it says so, instead of showing "Add source" where its status belongs.
 */
export const enListNoFile = {
	label: "No file uploaded",
	tooltip:
		"No file has been uploaded to this list. Its leads were added manually, and they stay exactly where they are. Upload a file if you want the list to enrich and run on its own.",
	cannotRun: "This list has no uploaded file to run on. Its leads were added manually.",
	sourcesStep:
		"No file has been uploaded to this list yet. Leads added by hand (Contacts → Add to list) stay in the list as usual — a file is only needed for the list to enrich and run on its own.",
};
